import { NotificationPayload } from '../../slices/notifications/types'
import { ccsApi } from './react'

const notifications: NotificationPayload<typeof ccsApi.endpoints>[] = [
  {
    endpoint: ccsApi.endpoints.clientTypeUpdate,
    tKey: 'updateClientType',
  },
  {
    endpoint: ccsApi.endpoints.addModule,
    tKey: 'addModule',
  },
  {
    endpoint: ccsApi.endpoints.updateModule,
    tKey: 'updateModule',
  },
  {
    endpoint: ccsApi.endpoints.addClientType,
    tKey: 'addClientType',
  },
  {
    endpoint: ccsApi.endpoints.clientTypeDelete,
    tKey: 'deleteClientType',
  },
  {
    endpoint: ccsApi.endpoints.createGenericModuleConfiguration,
    tKey: 'createGenericModuleConfiguration',
  },
  {
    endpoint: ccsApi.endpoints.updateGenericModuleCongifuration,
    tKey: 'updateGenericModuleCongifuration',
  },
  {
    endpoint: ccsApi.endpoints.downloadModule,
    tKey: 'downloadModule',
  },
  {
    endpoint: ccsApi.endpoints.importModule,
    tKey: 'importModule',
  },
]

export default notifications
